import InfoIcon from "@mui/icons-material/Info";
import { Box, IconButton, Stack, Tooltip } from "@mui/material";

import { useRoleContext, useShipment, useShipmentQuotes } from "hooks";
import {
  buildCarrierProfileEmergencyContactInfoURL,
  getBookedQuoteFromQuotes,
  getShipmentIdFromShipmentBookedChatName,
} from "utils";

import { ShipmentBookedBy } from "../ShipmentBookedBy";
import { LoadingChatConversationHeader } from "./LoadingChatConversationHeader";
import { MuteChatButton } from "./MuteChatButton";

interface Props {
  currentChannel: string;
}

export function ShipmentDetailChatConversationHeader(props: Props) {
  const { currentChannel } = props;
  const shipmentId = getShipmentIdFromShipmentBookedChatName(currentChannel);
  const { role } = useRoleContext();
  const { shipment, loading } = useShipment({
    shipmentId: parseInt(shipmentId, 10),
  });
  const { quotes, isLoading: loadingQuotes } = useShipmentQuotes(
    shipment?.info?.id,
  );
  const bookedQuote = getBookedQuoteFromQuotes(quotes);

  if (loading || shipment == null || !role || loadingQuotes) {
    return <LoadingChatConversationHeader />;
  }

  if (shipment.info.id.toString() !== shipmentId) {
    return null;
  }

  return (
    <Stack
      direction="row"
      spacing={2}
      p=".7rem"
      justifyContent="space-between"
      alignItems="center"
    >
      <Box>
        <ShipmentBookedBy shipment={shipment} isShipmentDetailChat />
      </Box>

      <Stack direction="row" spacing=".5">
        <MuteChatButton currentChannel={currentChannel} />
        {role.type === "SHIPPER" && bookedQuote && (
          <Tooltip title="Click to view carrier emergency contact information">
            <IconButton
              component="a"
              href={buildCarrierProfileEmergencyContactInfoURL(
                bookedQuote.created_by_company.id,
              )}
              target="_blank"
              rel="noopener noreferrer"
            >
              <InfoIcon />
            </IconButton>
          </Tooltip>
        )}
      </Stack>
    </Stack>
  );
}
